import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toDateParseFR } from "../../utils/datesHeures";
import { apiGetNotifications } from "../../api/ApiNotification";
import { Link } from "react-router-dom";
import { FaCog } from "react-icons/fa";

const ComponentModaleNotifierListe = (props) => {
  const { t } = useTranslation();
  const { showList, setShowList, instance, notificationsDejaCalculees } = props;
  const [notifications, setNotifications] = useState([]);

  const recupNotifications = async () => {
    const res = await apiGetNotifications(instance._id, "sort=-createdAt");
    setNotifications(res.data);
  };

  useEffect(() => {
    if (showList) {
      if (notificationsDejaCalculees) {
        // si j'ai fait passer des notifs dans le composant je fais pas d'appel réseau (cas de la page choix instance)
        setNotifications(notificationsDejaCalculees);
      } else {
        // sinon je recuperer toutes les notifs (cloche en haut)
        recupNotifications();
      }
    }
  }, [showList]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Modal show={showList} onHide={setShowList}>
      <Modal.Header closeButton>
        <Modal.Title>
          Notifications {instance.entite}{" "}
          <Link to="/notifications">
            <FaCog className="ms-3" role="button" size="0.8em" />
          </Link>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {notifications.map((notification, index) => (
          <div key={index} className="blocNotification">
            <div className="titleNotification">
              <span>
                {notification.importance != "normal" && (
                  <span className={"importanceNotification_" + notification.importance}>⚠ </span>
                )}
                {notification.title}
              </span>
              <span className="dateNotification">{toDateParseFR(notification.createdAt)}</span>
            </div>
            {/* <div className="dateNotification d-flex justify-content-between fst-italic">
              <span>
                {t("public.pageHome.publieLe")} {toDateParseFR(notification.createdAt)}
              </span>
              {notification.datePeremption && (
                <span>
                  {t("public.pageHome.validite")} {toDateParseFR(notification.datePeremption)}
                </span>
              )}
            </div> */}
            <p className="">{notification.body}</p>
          </div>
        ))}
      </Modal.Body>
    </Modal>
  );
};
export default ComponentModaleNotifierListe;
